import React from "react";
import styles from "./WhyChooseUs.module.css";

const REASONS = [
  {
    icon: "🏆",
    title: "Quality Workmanship",
    desc: "Every job — big or small — is done properly, the first time.",
  },
  {
    icon: "💰",
    title: "Reasonable Prices",
    desc: "Fair, straightforward pricing with no hidden charges.",
  },
  {
    icon: "🤝",
    title: "Dependable Service",
    desc: "We show up when we say we will and finish what we start.",
  },
  {
    icon: "🧹",
    title: "One Team, Every Job",
    desc: "Cleaning and renovation handled by people who know the work.",
  },
  {
    icon: "🗓️",
    title: "Flexible Scheduling",
    desc: "One-off jobs or recurring visits, on a schedule that suits you.",
  },
  {
    icon: "📱",
    title: "Easy to Reach",
    desc: "Message us anytime on WhatsApp for a quick, clear reply.",
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why-us" className={styles.section}>
      <div className="container">
        <div className={styles.heading}>
          <p className="jc-eyebrow">Why Choose Us</p>
          <h2 className={styles.title}>What working with us is actually like</h2>
          <p className={styles.desc}>
            No jargon, no run-around — just honest work and clear
            communication from the first message to the last mop stroke.
          </p>
        </div>

        <div className="row g-4">
          {REASONS.map((reason) => (
            <div className="col-12 col-sm-6 col-lg-4" key={reason.title}>
              <div className={styles.card}>
                <span className={styles.icon} aria-hidden="true">
                  {reason.icon}
                </span>
                <h3 className={styles.cardTitle}>{reason.title}</h3>
                <p className={styles.cardDesc}>{reason.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
